import { QueryClient } from '@tanstack/vue-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export const clearNonPersistentQueries = () => {
  const allQueries = queryClient.getQueryCache().findAll();

  // eslint-disable-next-line no-restricted-syntax
  for (const query of allQueries) {
    const { meta } = query.options;

    if (!meta?.persistOnLogout) {
      queryClient.removeQueries({
        queryKey: query.queryKey,
        exact: true,
      });
    }
  }
};
